import * as Three from 'three';
import React from 'react';
import { lineBreakWord } from '../../../common/functions/helperFunctions';

export default {
    name: 'voidNoProperties',
    prototype: 'items',

    info: {
        tag: [''],
        title: 'voidNoProperties',
        description: 'voidNoProperties',
        image: require('./void.PNG')
    },

    properties: {
        altitude: {
            label: 'altitude',
            type: 'length-measure',
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
        let width = 100;
        let depth = 50;
        let angle = element.rotation + 90;
        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }
        let desc = lineBreakWord(element.desc, 20);

        return (
            <g transform={`translate(${-width / 2},${-depth / 2})`}>
                <rect key="1" x='0' y='0' width={width} height={depth} style={style} />
                <line key="2" x1={0} y1={0} x2={width} y2={depth} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
                <line key="3" x1={width} y1={0} x2={0} y2={depth} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
                <text key="8" x="0" y="0"
                    transform={`translate(${width / 2}, ${textRotation === 0 ? -5 : depth + 5}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    }
};
